import { NgModule } from '@angular/core';

import { FeatherModule } from 'angular-feather';
import {Minimize2,Maximize2,Tool,MessageSquare,RotateCw,Minus,Plus,Upload,TrendingUp,Copy,Search,BatteryCharging,Briefcase, Inbox,Key,Info, X,Check,Eye,EyeOff,Settings,Home,LogOut,Menu,Paperclip,Layers,ShoppingCart,Edit,UserCheck,ArrowUpCircle,ArrowRight,ArrowLeft,ChevronsLeft,ChevronsRight,ChevronRight,ChevronDown,Mail,Camera, Heart, Github, Trash2, ExternalLink,MinusCircle, PlusCircle,Download, User,  FileText,  Table, Save,XCircle ,XOctagon, ArrowLeftCircle,AlignLeft,Share2,Link, Database, Filter, PauseCircle } from 'angular-feather/icons';

// Select some icons (use an object, not an array)
const icons = {
  Minimize2,
  Maximize2,
    Tool,
  Camera,
  Heart,
  Github,
  Trash2,
  ExternalLink	,
  PlusCircle,
  MinusCircle,
  Download,
  User,
  FileText,
  Table,
  Save,
  XCircle,
  XOctagon,
  ArrowLeft,
  ArrowLeftCircle,
  AlignLeft,
  Share2,
  ArrowRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronRight,
  ChevronDown,
  Mail,
  ArrowUpCircle,
  UserCheck,
  Edit,
  ShoppingCart,
  Layers,
  Paperclip,
  Menu,
  LogOut,
  Home,
  Settings,
  Eye,
  EyeOff,
  Check,
  X,
  Info,
  Key,
  Inbox,
  Briefcase,
  BatteryCharging,
  Search,
  Copy,
  TrendingUp,
  Upload,
  Minus,
  Plus,
  RotateCw,
  MessageSquare,
  Link,
  Database,
  Filter,
  PauseCircle,
};

@NgModule({
  imports: [
    FeatherModule.pick(icons)
  ],
  exports: [
    FeatherModule
  ]
})
export class IconsModule { }